import PropTypes from "prop-types";
import { useMemo } from "react";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

function FormPhoneDisplayField({ value }) {
    // Ensuring that value is converted to E.164 format
    const phoneNumber = useMemo(() => {
        if (!value) {
            return "";
        }

        try {
            return parsePhoneNumber(value);
        } catch (e) {
            // Fallback to an empty value if parsing fails to avoid breaking render
            return "";
        }
    }, [value]);

    return phoneNumber ? (
        <PhoneInput value={phoneNumber?.number ?? ""} onChange={() => null} disabled={true} />
    ) : (
        // Show value as-is if not international phone format
        value
    );
}

FormPhoneDisplayField.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
};

export default FormPhoneDisplayField;
